import { render } from "./PageComponents.vue?vue&type=template&id=1e8631fa"
import script from "./PageComponents.vue?vue&type=script&lang=js"
export * from "./PageComponents.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__